import { Link } from "react-router-dom";
import { AlertTriangle, Sparkles } from "lucide-react";
import { useFeatures } from "../../Moduels/Subscription/FeaturesContext";

export default function SubscriptionBanner() {
  const { status, plan, trial_ends_at, loaded } = useFeatures() || {};

  if (!loaded || !status || status === "active" || status === "none") return null;

  const isTrial = status === "trial";
  const isGrace = status === "grace";
  const isBlocked = ["suspended", "expired", "cancelled", "payment_failed"].includes(status);

  let message = "";
  if (isTrial && trial_ends_at) {
    message = `Free trial active on ${plan?.name || "your"} plan — ends ${trial_ends_at.slice(0, 10)}.`;
  } else if (isGrace) {
    message = "Your subscription is in grace period. Renew now to avoid suspension.";
  } else if (isBlocked) {
    message = "Your subscription is inactive. Renew to restore full access.";
  } else if (status === "renewal_due") {
    message = "Renewal is due. Update billing to continue uninterrupted service.";
  } else {
    return null;
  }

  return (
    <div className={`sub-banner ${isBlocked ? "sub-banner-danger" : "sub-banner-warn"}`}>
      <span className="sub-banner-icon">{isBlocked ? <AlertTriangle size={16} /> : <Sparkles size={16} />}</span>
      <span className="sub-banner-text">{message}</span>
      <Link to="/settings/subscription" className="sub-banner-link">Billing</Link>
    </div>
  );
}
